/**
 * useUserHandicaps — Fetch current user's available handicaps
 */

import { useUserAvailableHandicaps } from '../api/extensions/useHandicapOps';
import { useAuthStore } from '../state_management_and_stores/auth.store';

export function useUserHandicaps(orgId?: string) {
  const profile = useAuthStore((s) => s.profile);
  const userId = profile?.id || '';

  return useUserAvailableHandicaps(userId, orgId);
}
